import {CreateOperationContent}  from "./OperationContent";
import { Content } from "./ContentBase";
import {ComponentType} from "./ContentComponent";
import {Operation} from "./OperationBase";

export function CreateContentArray(v:any[],setContent:(newContent:Node)=>void,curComp:ComponentType):Content {
  let arrOps:Operation[]=[];
  let Comments:Comment[]=[];

  function AddOne(content:any) {
    const idx=arrOps.length;
    let cmt=document.createComment("");
    let cc=Comments[idx];
    Comments.splice(idx,0,cmt);
    cc.parentNode.insertBefore(cmt, cc);
    arrOps.push(CreateOperationContent((newContent:Node)=>{
      let r=document.createRange();
      r.setStartAfter(Comments[idx]);
      r.setEndBefore(Comments[idx+1]);
      r.deleteContents();
      if(newContent) r.insertNode(newContent);
    },-1,curComp,content));
  }
  
  function RemoveOne(idx:number) {
    let r=document.createRange();
    r.setStartAfter(Comments[idx]);
    r.setEndAfter(Comments[idx+1]);
    r.deleteContents();
    Comments.splice(idx+1,1);
    arrOps[idx].Unload();
    arrOps.splice(idx,1);
  }
  
  //let tmpl=document.createElement("template");
  let frag=new DocumentFragment();
  let cmt=document.createComment("");
  Comments.push(cmt);
  frag.append(cmt);
  for(const itm of v) AddOne(itm);
  setContent(frag);
  
  return {
    Update:items=>{
      for(let i=0;i<items.length || i<arrOps.length;i++) {
        if(i<items.length && i<arrOps.length) {
          arrOps[i].Update(items[i])
        } else if (items.length<arrOps.length) {
          // new length is less - so delete remaining
          RemoveOne(i);
          i-=1;
        } else {
          // new length is more - so insert remaining
          AddOne(items[i]);
        }
      }
    },

    Unload:()=>{arrOps.forEach(op=>op.Unload());arrOps=[]},

    MatchForUpdate:v=>true
  }
}
